import { Edit } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { FUNDING_NEW_VEHICLE_CONSTANT, USER_CONTROL } from "./popupMessage";
import { TypeName } from "./typeName";

export const fundingNewVehicleMatchData = [
  FUNDING_NEW_VEHICLE_CONSTANT.SET_FUNDING_TYPE,
  FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MAKE,
  FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MODEL,
  FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_YEAR,
  FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_FUEL,
];

export const sidebarMenu = {
  dashboard: "Dashboard",
  fleetList: "Current Fleet Details",
  replacement: "Strategic Replacement Plan",
  maintenance: "Maintenance & Repair Cost Comparison",
  fuel: "Fuel Economy Comparison",
  newVehicle: "Recommended Acquisition Strategy",
  analysisResult: "Suggested 5-Year Plan & Cost Comparison Analysis",
  reports: "Reports",
};
export const getCompanyId = (userType, companyNameHeader) => {
  let companyId;
  if (userType === "admin") {
    companyId = companyNameHeader?.id;
  } else {
    companyId = companyNameHeader?.companyId
      ? companyNameHeader?.companyId
      : companyNameHeader?.id;
  }
  return companyId;
};

export const formatVehicleIdentifier = (identifier) => {
  if (identifier == null) return identifier;
  return String(identifier).replace(/^FL(?=\d)/i, "VN");
};

export const mergeCalculatedComtracValues = (rows = [], values = {}) => {
  if (!Array.isArray(rows) || rows.length === 0) return rows;

  const toNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  };

  const paymentAmount = toNumber(values?.totalMonthlyPayment ?? values?.monthlyPayment);
  const netCapitalizedCost = toNumber(values?.netCapitalizedCost ?? values?.vehicleSellingPrice);
  const residualPercentage = toNumber(
    values?.residualPercentage ?? values?.dealStructure?.residualPercent ?? values?.dealStructure?.residualPercentage
  );
  const residualAmount = toNumber(values?.residualAmount ?? values?.dealStructure?.residualAmount);
  const termMonths = toNumber(values?.termMonths ?? values?.dealStructure?.termMonths);
  const years = termMonths != null ? Math.round(termMonths / 12) : null;

  return rows.map((row) => {
    const rowResaleValue = toNumber(row.newEstimatedResaleValue);
    const rowResidualPercent = toNumber(row.residualPercentage);
    const rowCost = toNumber(row.newVehicleCost);
    const rowEquity = toNumber(row.equityGain);

    const nextResidualPercent = residualPercentage ?? rowResidualPercent;
    const nextCost = netCapitalizedCost ?? rowCost;
    const nextPaymentAmount = paymentAmount ?? toNumber(row.paymentAmount);
    const nextResidualAmount = residualAmount ?? (nextCost != null && nextResidualPercent != null ? nextCost * (nextResidualPercent / 100) : null);
    const baseResaleValue = toNumber(values?.newEstimatedResaleValue ?? rowResaleValue ?? 0);

    const equityGain =
      baseResaleValue != null && nextResidualAmount != null
        ? Number((baseResaleValue - nextResidualAmount).toFixed(2))
        : rowEquity;

    return {
      ...row,
      ...(nextPaymentAmount != null && { paymentAmount: Number(nextPaymentAmount.toFixed(2)) }),
      ...(nextCost != null && { newVehicleCost: Number(nextCost.toFixed(2)) }),
      ...(nextResidualPercent != null && { residualPercentage: Number(nextResidualPercent.toFixed(2)) }),
      ...(values?.newEstimatedResaleValue != null && { newEstimatedResaleValue: Number(toNumber(values.newEstimatedResaleValue).toFixed(2)) }),
      ...(equityGain != null && { equityGain: Number(equityGain.toFixed(2)) }),
      ...(termMonths != null && { termMonths: Number(termMonths) }),
      ...(years != null && { years, proposedCycle: years }),
    };
  });
};

export const typeConstant = {
  dealer: "user",
  admin: "admin",
};

export const getCellClass = (field, params) => {
  switch (field) {
    case "annualNeeds":
      return params.node.rowIndex !== 0 ? "" : "cellColorAnalysis";
    case "purchasedFinancial":
    case "currentPayment":
      return params.node ? "cellColorAnalysis" : "";
    case "cashOutlay":
      return params.node.rowIndex == 0 ? "" : "cellColorAnalysis";
    case "vehicleEquity":
      return "cellColorAnalysis";
    default:
      return "";
  }
};

export const getDealerId = (userType, dealer, dealerName) => {
  let companyId;
  let dealerId = [];
  if (userType == typeConstant.dealer) {
  } else {
    dealer?.map((items) => {
      if (items?.dealerName == dealerName) {
        dealerId.push(items);
      }
    });
  }

  return dealerId[0];
};

function checkDealerId(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
}

export const transformData = (ids, equityGains, value) => {
  return ids.map((id, index) => ({
    id: id,
    equityGain: equityGains[index],
  }));
};
export const formatChartTooltipValue = (val) => {
  if (val == null) {
    return "0 thousands";
  } else {
    return `${val.toFixed(2)} thousands`;
  }
};
export const formatDonutChartTooltipValue = (val) => {
  if (val == null) {
    return "0";
  } else {
    return `${val.toFixed(2)}`;
  }
};

export const checkFieldColumn = (event) => {
  if (
    event?.colDef?.headerName !== "Action" &&
    event?.colDef?.field !== "checkbox"
  ) {
    return true;
  } else {
    return false;
  }
};

export const checkbox = {
  field: "checkbox",
  headerName: "",
  sortable: false,
  minWidth: 50,
  maxWidth: 50,
  checkboxSelection: true,
  headerCheckboxSelection: "checkbox",
  headerCheckboxSelectionFilteredOnly: true,
};

export const actionColumnFunction = ({
  selectedRows,
  handleEditButton,
  handleDeleteButton,
  deleteButton,
}) => {
  let actionColumn = {
    field: "action",
    headerName: "Action",
    headerTooltip: "Action",
    sortable: false,
    resizable: true,
    width: 92,
    minWidth: 88,
    pinned: "right",
    suppressSizeToFit: true,
    cellRenderer: (params) => (
      <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '4px' }}>
        <IconButton
          sx={{
            color: selectedRows?.includes(params?.id) ? "white" : "#10B981",
          }}
          onClick={() => handleEditButton(params.data)}
        >
          <Edit htmlColor={selectedRows?.includes(params?.id) ? "white" : "#10B981"} />
        </IconButton>
        {deleteButton && (
          <IconButton
            sx={{
              color: selectedRows?.includes(params?.id) ? "white" : "#EF4444",
            }}
            onClick={() => handleDeleteButton(params.data)}
          >
            <DeleteIcon htmlColor={selectedRows?.includes(params?.id) ? "white" : "#EF4444"} />
          </IconButton>
        )}
      </div>
    ),
  };

  return actionColumn;
};

export const ensureHeaderTooltip = (columns) => {
  if (!Array.isArray(columns)) return columns;
  return columns.map((col) => {
    if (!col) return col;
    const name = col.headerName
      ? String(col.headerName).trim()
      : col.field
        ? String(col.field).trim()
        : "";
    if (name && col.field !== "checkbox") {
      return {
        ...col,
        headerTooltip: col.headerTooltip || name,
      };
    }
    return col;
  });
};

export const getDefaultColDef = () => {
  return {
    flex: 1,
    minWidth: 110,
    tooltipValueGetter: (params) => params.value,
    menuTabs: ["filterMenuTab"],
    filter: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    resizable: true,
    headerClass: "fleet-grid-header",
  };
};

export const setModalContentByAction = ({
  action,
  setModalContent,
  setReplaceVehicleOpen,
}) => {
  switch (action) {
    case "setPaymentAmount":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_PAYMENT_AMOUNT);
      break;
    case "setFundingType":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_FUNDING_TYPE);
      break;
    case "setNewVehicleMake":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MAKE);
      break;
    case "setNewVehicleModel":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MODEL);
      break;
    case "setNewVehicleYear":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_YEAR);
      break;
    case "setNewVehicleCost":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_COST);
      break;
    case "setNewVehicleMPG":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_MPG);
      break;
    case "setNewFuel":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_VEHICLE_FUEL);
      break;
    case "setResidual":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_RESIDUAL);
      break;
    case "setNewEstimatedResaleValue":
      setModalContent(
        FUNDING_NEW_VEHICLE_CONSTANT.SET_NEW_ESTIMATES_RESALE_VALUE,
      );
      break;
    case "replaceExistingVehicle":
      setReplaceVehicleOpen(true);
      break;
    case "setAll":
      setModalContent(FUNDING_NEW_VEHICLE_CONSTANT.SET_ALL);
      break;
    default:
      // Handle default case if needed
      break;
  }
};

export function extractValue(obj, property, delimiter = "$", index = 1) {
  if (obj?.[property]) {
    return obj?.[property]?.split(delimiter)?.[index];
  } else {
    return "0";
  }
}

export const getFileName = (prefix) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${prefix}_${day}${month}${year}`;
};

export const setModelContentByActionFleetList = ({
  action,
  key,
  selectedRows,
  handleExport,
  handleDeleteButton,
  setKeyValue,
  setModalContent,
}) => {
  switch (action) {
    case "export":
      handleExport();
      break;
    case "delete":
      handleDeleteButton(selectedRows);
      break;
    default:
      setKeyValue(key);
      switch (action) {
        case "setFuel":
          setModalContent("Set Fuel");
          break;
        case "setType":
          setModalContent("Set Type");
          break;
        case "setDriveTrain":
          setModalContent("Set Drive Train");
          break;
        case "setYear":
          setModalContent("Set Year");
          break;
        case "setMake":
          setModalContent("Set Make");
          break;
        case "setModel":
          setModalContent("Set Model");
          break;
        case "setMPG":
          setModalContent("Set MPG");
          break;
        case "groupType":
          setModalContent("Set Group Type");
          break;
        case "setAll":
          setModalContent("Set All");
          break;
        case "driverName":
          setModalContent("Set DriverName");
        case "State":
          setModalContent("Set Location");
          break;
        default:
          break;
      }
      break;
  }
};

export const getCpmCategory = (data) => {
  const lowerData = data.toLowerCase();
  if ([TypeName.suv, TypeName.sedan, TypeName.LD, TypeName.VAN].includes(lowerData)) {
    return "Standard";
  } else if (lowerData === TypeName.EV) {
    return "EV";
  } else if ([TypeName.MD, TypeName.HD].includes(lowerData)) {
    return "MD";
  } else {
    return "";
  }
};

export const userControl = ({
  handleDeactivate,
  handleReactivate,
  classes,
}) => {
  let userControlColumn = {
    field: "userControl",
    headerName: "User Control",
    headerTooltip: "User Control",
    sortable: false,
    resizable: true,
    minWidth: 150,
    cellRenderer: (params) => (
      <>
        {params.data.status === USER_CONTROL.ACTIVATE && (
          <Button
            className={classes.addFleetListButton}
            style={{
              color: "black",
            }}
            onClick={() => handleDeactivate(params.data)}
          >
            Deactivate
          </Button>
        )}
        {params.data.status === USER_CONTROL.DEACTIVATE && (
          <Button
            className={classes.buttonReactive}
            style={{
              color: "black",
            }}
            onClick={() => handleReactivate(params?.data)}
          >
            Reactivate
          </Button>
        )}
      </>
    ),
  };

  return userControlColumn;
};

export const onGridReady = (params, setGridApi) => {
  setGridApi(params.api);
};
